var alignmentStyle = {"alignLeft":"dxKFW","textWrapNowrap":"NL6qW","alignRight":"_27tKV","alignCenter":"HBhzj","sizeFullWidth":"upLcH","renderedInTable":"X1a6f","sizeOriginal":"qAS6x","sizeContent":"x1ybQ","sizeSmall":"VylzF","sizeSmallCenter":"jEMA-","flex":"oqpra","LEFT":"SiM0W","CENTER":"RZJ-7","RIGHT":"sveks","AUTO":"_2Enfw","JUSTIFY":"mMaDG"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-aa5bbcaa.js.map
